import { CaseState } from 'app/area/case/types-store';
import { ApplicationState } from 'app/types-store';

export const currentUser = (state: CaseState, uiEngineProps: any, appState: ApplicationState) => {
    
  return { 
    currentUser: {
      description: appState.app.userInfo.name,
      value: appState.app.userInfo.id
    }
  };
};
